"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInlineObject5 = void 0;
const iinventory_search_entity_1 = require("./iinventory-search-entity");
function parseInlineObject5(data) {
    if (data.inventory_filter !== null && typeof data.inventory_filter === 'object')
        data.inventory_filter = (0, iinventory_search_entity_1.parseIInventorySearchEntity)(data.inventory_filter);
    return data;
}
exports.parseInlineObject5 = parseInlineObject5;
